import { render, staticRenderFns } from "./TwMail.vue?vue&type=template&id=8f9361ec&scoped=true&"
import script from "./TwMail.vue?vue&type=script&lang=js&"
export * from "./TwMail.vue?vue&type=script&lang=js&"
import style0 from "./TwMail.vue?vue&type=style&index=0&id=8f9361ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9361ec",
  null
  
)

export default component.exports